


























































import Vue from "vue";

// Model
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";
import { InstallationTypeEnum, installationTypeEnumLabel } from "@/model/data/enums/InstallationTypeEnum";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";
import { formatCurrency } from "@/utility/Formatter";

// Vue components
import BranchReportSigleTable from "./BranchReportSigleTable.vue";
import { RootState } from "@/store";

export default Vue.extend({
    components: {
        BranchReportSigleTable,
    },
    data() {
        return {
            InstallationTypeEnum,
            CashTypeEnum,
            showBalancing: true,
            cashType: null,
            selectedCashType: null,
        };
    },
    props: {
        loading: Boolean,
        detailsLoading: Boolean,
        currentFilters: Object,
        frontOfficeCashFlowSummaryInstallations: Array,
        backOfficeCashFlowSummaryInstallations: Array,
    },
    computed: {
        tables() {
            let res = [];

            let frontOfficeInstallations = this.frontOfficeCashFlowSummaryInstallations;
            let backOfficeInstallations = this.backOfficeCashFlowSummaryInstallations;

            if (frontOfficeInstallations != null && frontOfficeInstallations.length > 0)
                res.push({
                    installations: frontOfficeInstallations,
                    totals: {
                        cashIn: frontOfficeInstallations.reduce((sum, c) => sum + c.cashIn, 0),
                        cashOut: frontOfficeInstallations.reduce((sum, c) => sum + c.cashOut, 0),
                        balance: frontOfficeInstallations.reduce((sum, c) => sum + c.balance, 0),
                        paymentsExpectedAmount: frontOfficeInstallations.reduce((sum, c) => sum + c.paymentsExpectedAmount, 0),
                        paymentsAmount: frontOfficeInstallations.reduce((sum, c) => sum + c.paymentsAmount, 0),
                        notPaidChange: frontOfficeInstallations.reduce((sum, c) => sum + c.notPaidChange, 0),
                        withdrawal: frontOfficeInstallations.reduce((sum, c) => sum + c.withdrawal, 0),
                        fromOtherOffice: {
                            banknoteCashValue: frontOfficeInstallations.reduce((sum, c) => sum + c.fromOtherOffice.banknoteCashValue, 0),
                            coinCashValue: frontOfficeInstallations.reduce((sum, c) => sum + c.fromOtherOffice.coinCashValue, 0),
                        },
                        toOtherOffice: {
                            banknoteCashValue: frontOfficeInstallations.reduce((sum, c) => sum + c.toOtherOffice.banknoteCashValue, 0),
                            coinCashValue: frontOfficeInstallations.reduce((sum, c) => sum + c.toOtherOffice.coinCashValue, 0),
                        },
                    },
                });

            if (backOfficeInstallations != null && backOfficeInstallations.length > 0)
                res.push({
                    installations: backOfficeInstallations,
                    totals: {
                        cashIn: backOfficeInstallations.reduce((sum, c) => sum + c.cashIn, 0),
                        cashOut: backOfficeInstallations.reduce((sum, c) => sum + c.cashOut, 0),
                        balance: backOfficeInstallations.reduce((sum, c) => sum + c.balance, 0),
                        cashiersBalance: backOfficeInstallations.reduce((sum, c) => sum + c.cashiersBalance, 0),
                        refillsAmount: backOfficeInstallations.reduce((sum, c) => sum + c.refillsAmount, 0),
                        depositedInBagAmount: backOfficeInstallations.reduce((sum, c) => sum + c.depositedInBagAmount, 0),
                        emptyBagAmount: backOfficeInstallations.reduce((sum, c) => sum + c.emptyBagAmount, 0),
                        fromOtherOffice: {
                            banknoteCashValue: backOfficeInstallations.reduce((sum, c) => sum + c.fromOtherOffice.banknoteCashValue, 0),
                            coinCashValue: backOfficeInstallations.reduce((sum, c) => sum + c.fromOtherOffice.coinCashValue, 0),
                        },
                        toOtherOffice: {
                            banknoteCashValue: backOfficeInstallations.reduce((sum, c) => sum + c.toOtherOffice.banknoteCashValue, 0),
                            coinCashValue: backOfficeInstallations.reduce((sum, c) => sum + c.toOtherOffice.coinCashValue, 0),
                        },
                    },
                });

            return res;
        },

        currentCurrency() {
            if (this.frontOfficeCashFlowSummaryInstallations.length > 0) return this.frontOfficeCashFlowSummaryInstallations[0].currency;
            else if (this.backOfficeCashFlowSummaryInstallations.length > 0) return this.backOfficeCashFlowSummaryInstallations[0].currency;
            return "";
        },

        currentBranchName() {
            if (this.frontOfficeCashFlowSummaryInstallations.length > 0) return this.frontOfficeCashFlowSummaryInstallations[0].branch.name;
            else if (this.backOfficeCashFlowSummaryInstallations.length > 0) return this.backOfficeCashFlowSummaryInstallations[0].branch.name;
            return "";
        },

        something() {
            return this.frontOfficeCashFlowSummaryInstallations.length > 0 || this.backOfficeCashFlowSummaryInstallations.length > 0;
        },

        branchIncomes() {
            let res = 0;
            if (this.frontOfficeCashFlowSummaryInstallations && this.frontOfficeCashFlowSummaryInstallations.length > 0)
                res = res + this.frontOfficeCashFlowSummaryInstallations.reduce((sum, c) => sum + c.paymentsAmount, 0);
            if (this.backOfficeCashFlowSummaryInstallations && this.backOfficeCashFlowSummaryInstallations.length > 0)
                res = res + this.backOfficeCashFlowSummaryInstallations.reduce((sum, c) => sum + c.cashiersBalance, 0);
            return res;
        },

        showAlert_FFO_lessThan_TBO() {
            return (
                this.getFFO(CashTypeEnum.Unknown) < this.getTBO(CashTypeEnum.Unknown) &&
                this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.FrontOffice).length > 0 &&
                this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.BackOffice).length > 0
            );
        },

        showAlert_FBO_lessThan_TFO() {
            return (
                this.getFBO(CashTypeEnum.Unknown) < this.getTFO(CashTypeEnum.Unknown) &&
                this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.FrontOffice).length > 0 &&
                this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.BackOffice).length > 0
            );
        },

        showAlert_FFO_moreThan_TBO() {
            return (
                this.getFFO(CashTypeEnum.Unknown) > this.getTBO(CashTypeEnum.Unknown) &&
                this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.FrontOffice).length > 0 &&
                this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.BackOffice).length > 0
            );
        },

        showAlert_FBO_moreThan_TFO() {
            return (
                this.getFBO(CashTypeEnum.Unknown) > this.getTFO(CashTypeEnum.Unknown) &&
                this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.FrontOffice).length > 0 &&
                this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.BackOffice).length > 0
            );
        },

        mainSectionBackgroundColor() {
            if ((this.$store.state as RootState).authMod.currentUser.userConfig != null)
                return (this.$store.state as RootState).authMod.currentUser.userConfig.theme != "dark" ? "grey lighten-4" : "";
            else return "";
        },
    },
    watch: {
        async selectedCashType(value) {
            this.currentFilters.cashType = value;
            this.accountingBalancingLoading = true;
            await setTimeout(() => {
                this.cashType = value;
                this.accountingBalancingLoading = false;
            }, 500);
        },

        showBalancing(value) {
            LocalStorageManager.Write(LocalStorageRequests.ShowBalancing, value as string);
        },
    },
    methods: {
        installationTypeEnumLabel,
        formatCurrency,

        getFBO(cashType: CashTypeEnum) {
            if (this.tables.length <= 0 || this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.FrontOffice).length == 0) return 0;
            let total = this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.FrontOffice)[0].totals.fromOtherOffice;
            if (cashType == CashTypeEnum.Unknown) return total.banknoteCashValue + total.coinCashValue;
            else if (cashType == CashTypeEnum.Banknote) return total.banknoteCashValue;
            return total.coinCashValue;
        },

        getTBO(cashType: CashTypeEnum) {
            if (this.tables.length <= 0 || this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.FrontOffice).length == 0) return 0;
            let total = this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.FrontOffice)[0].totals.toOtherOffice;
            if (cashType == CashTypeEnum.Unknown) return total.banknoteCashValue + total.coinCashValue;
            else if (cashType == CashTypeEnum.Banknote) return total.banknoteCashValue;
            return total.coinCashValue;
        },

        getTFO(cashType: CashTypeEnum) {
            if (this.tables.length <= 0 || this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.BackOffice).length == 0) return 0;
            let total = this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.BackOffice)[0].totals.toOtherOffice;
            if (cashType == CashTypeEnum.Unknown) return total.banknoteCashValue + total.coinCashValue;
            else if (cashType == CashTypeEnum.Banknote) return total.banknoteCashValue;
            return total.coinCashValue;
        },

        getFFO(cashType: CashTypeEnum) {
            if (this.tables.length <= 0 || this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.BackOffice).length == 0) return 0;
            let total = this.tables.filter((t) => t.installations[0].installationType == InstallationTypeEnum.BackOffice)[0].totals.fromOtherOffice;
            if (cashType == CashTypeEnum.Unknown) return total.banknoteCashValue + total.coinCashValue;
            else if (cashType == CashTypeEnum.Banknote) return total.banknoteCashValue;
            return total.coinCashValue;
        },
    },
    mounted() {
        this.selectedCashType = CashTypeEnum.Unknown;
        const val = LocalStorageManager.Read(LocalStorageRequests.ShowBalancing);
        this.showBalancing = val != null ? JSON.parse(val) : false;
    },
});
